import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import {
  selectShippingOption,
  refreshShippingOptions
} from 'shared/components/cart/actions';
import { setShippingOption as setCheckoutShippingOption } from './actions';
import scrollIntoView from 'scroll-into-view';
import LoadingSpinner from 'shared/components/ui/loadingSpinner';
import RadioButton from 'shared/components/ui/radioButton';
import { withConjunction } from 'shared/utils';

const Icon = () => <span className="svg-icon svg-icon--delivery" />;

let Collapsed = class Collapsed extends React.Component {
  render() {
    return this.props.selectedOption ? (
      <div className="checkout-section__title checkout-section__title--selected">
        {this.props.selectedOption.name}
      </div>
    ) : (
      <h2 className="checkout-section__title">Shipping</h2>
    );
  }
};

Collapsed = connect(
  state => ({
    selectedOption: state.checkout.shippingOption
  }),
  {}
)(Collapsed);

let Expanded = class Expanded extends React.Component {
  componentDidMount() {
    const containerRect = this.container.getBoundingClientRect();
    if (containerRect && containerRect.top < 0) scrollIntoView(this.container);

    if (this.props.shippingOptions.length === 0) {
      return this.props.refreshShippingOptions();
    } else if (!this.props.selectedShippingOption) {
      return this.preselectOption();
    }
  }

  componentDidUpdate() {
    if (this.props.cartProducts.length === 0) {
      this.props.collapse();
    }
  }

  preselectOption() {
    const option = this.props.shippingOptions[0];
    if (option && _.isEmpty(this.props.selectedOption)) {
      return this.selectOption(option);
    }
  }

  selectOption(option) {
    return this.props.selectShippingOption(option, { checkout: true });
  }

  handleSubmit(e) {
    e.preventDefault();
    return this.props
      .setCheckoutShippingOption(this.props.cartShippingOption)
      .then(() => this.props.collapse());
  }

  render() {
    const shippingOptions = this.props.shippingOptions || [];
    const selectedOption =
      this.props.cartShippingOption || this.props.selectedOption || {};
    const disabled =
      _.isEmpty(selectedOption) || this.props.shippingOptionsLoading;
    const specialOrderProducts = this.props.cartProducts.filter(
      product => product.special_order
    );

    return (
      <div
        className="checkout-form-container"
        ref={div => (this.container = div)}
      >
        <h2 className="checkout-section__title checkout-section__title--expanded">
          Shipping
        </h2>

        <form onSubmit={e => this.handleSubmit(e)}>
          {!!specialOrderProducts.length && (
            <div className="warning">
              {withConjunction(
                specialOrderProducts.map(product =>
                  `${product.title} ${product.subtitle}`.trim()
                )
              )}{' '}
              may require 2-3 days to process.
            </div>
          )}

          <div className="vertical-rhythm radio-list">
            {this.props.shippingOptionsLoading && <LoadingSpinner green />}

            {shippingOptions.map(option => {
              const key = `${option.name} ${option.price}`;
              const name = 'shipping';
              const id = `${name}_${option.name.replace(/\s+/g, '-')}`;
              const isChecked = selectedOption.name === option.name;
              const containerClass = isChecked
                ? 'radio-list__option radio-list__option--checked'
                : 'radio-list__option';
              const btnClass = isChecked
                ? 'radio-list__radio-btn radio-list__radio-btn--checked'
                : 'radio-list__radio-btn';
              const titleClass = isChecked ? 'radio-list__strong' : '';
              const labelClass = isChecked
                ? 'radio-list__label radio-list__strong'
                : 'radio-list__label';

              return (
                <RadioButton
                  key={key}
                  name={name}
                  id={id}
                  checked={isChecked}
                  containerClass={containerClass}
                  onChange={() => this.selectOption(option)}
                  btnClass={btnClass}
                >
                  <div className="radio-list__content">
                    <div className="row middle-xs">
                      <div className="col-xs">
                        <div className={titleClass}>{option.name}</div>
                      </div>
                      <div className="col-xs-3">
                        <div className={labelClass}>
                          ${option.price && option.price.toFixed(2)}
                        </div>
                      </div>
                    </div>
                  </div>
                </RadioButton>
              );
            })}
          </div>

          <div className="row">
            <div className="col-xs-12 col-md-5 col-md-offset-7 col-lg-4 col-lg-offset-8">
              <button
                type="submit"
                className="btn-primary green btn--full-width"
                disabled={disabled}
              >
                Continue
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
};

Expanded = connect(
  state => ({
    address: state.address,
    shippingOptions: state.cart.shippingOptions || [],
    shippingOptionsLoading: state.cart.shippingOptionsLoading,
    selectedOption: state.checkout.shippingOption,
    cartShippingOption: state.cart.selectedShippingOption,
    cartFee: state.cart.fee,
    cartProducts: state.cart.products
  }),
  {
    refreshShippingOptions,
    selectShippingOption,
    setCheckoutShippingOption
  }
)(Expanded);

export default {
  Icon,
  Collapsed,
  Expanded
};



// WEBPACK FOOTER //
// ./shared/components/checkoutPage/shippingOptions.js